<template>
  <div class="bg-white">
    <header class="mb-2">
      <!-- <h2 class="fsize36 sm-fsize28 font-bold mb-3">
        Welcome back,
        {{
          userData.firstname.charAt(0).toUpperCase() +
          userData.firstname.slice(1)
        }}
      </h2> -->
      <!-- <p class="fsize20 sm-fsize16 lg:font-normal md:font-normal font-medium">
        Ready for your next lesson?
      </p> -->
    </header>
    <section class="grid lg:grid-cols-2 md:grid-cols-2 gap-8">
      <b-card
        no-body
        v-for="(item, index) in courses"
        :key="index"
        class="rounded-xl cursor-pointer"
        @click="getCourse('learningCourses', item)"
      >
        <div class="lg:flex">
          <div class="lg:w-1/2 w-full">
            <img
              :src="$imageURL + '/' + item.icone"
              alt="img"
              class="w-full rounded-xl card-img-h263px object-cover"
            />
          </div>
          <div class="lg:w-1/2 w-full lg:p-8 md:p-4 p-6">
            <h5 class="font-bold fsize20">{{ item.name }}</h5>
            <p class="fsize14 font-medium mt-2">
              {{
                item.author
                  .map(
                    (data) => data.userId.firstname + " " + data.userId.lastname
                  )
                  .toString()
              }}
            </p>
            <div>
              <div class="progress-default">
                <div class="progress-percentage">
                  <span>{{ Math.floor(getTotalPercentage(item)) }}%</span>
                </div>
              </div>
              <base-progress
                :height="12"
                type="warning"
                :value="getTotalPercentage(item)"
                size="lg"
              >
                <slot label> da </slot>
              </base-progress>
            </div>
            <p class="meta font-semibold text-primary fsize18 sm-fsize14">
              LESSON {{ getCompletedTopics(item) }} OF
              {{ getTotalTopics(item) }}
            </p>
            <p
              class="btn btn-sm btn-danger mt-2 cursor-pointer"
              @click.stop="certificate(item)"
              v-if="getTotalPercentage(item) == 100 && item.appr == true"
            >
              Certificate
            </p>

            <button
              :disabled="!isDisable"
              class="btn btn-sm btn-danger mt-2 cursor-pointer"
              @click.stop="getCertificate()"
              v-else-if="getTotalPercentage(item) == 100 && item.appr == false"
            >
              Get Certificate
            </button>
          </div>
        </div>
      </b-card>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      appr: true,
      isDisable: false,

      // cards: [
      //   {
      //     id: "01",
      //     img: require("@/assets/images/mylearning/1.png"),
      //     title: "Microsoft Excel - Excel from Beginner to Advanced",
      //     mute: "Shobuj Roy",
      //     hours: "LESSON 23 OF 46 | 2m",
      //   },
      //   {
      //     id: "02",
      //     img: require("@/assets/images/mylearning/2.png"),
      //     title: "Microsoft Excel - Excel from Beginner to Advanced",
      //     mute: "Shobuj Roy",
      //     hours: "LESSON 23 OF 46 | 2m",
      //   },
      // ],
      courses: [],
      learning: [],

      // topic: []
    };
  },
  methods: {
    async getStudent() {
      try {
        const { data } = await this.$store.dispatch(
          "student/getStudentByUserId",
          {
            userId: this.userData._id,
          }
        );
        this.courses = data[0].course;

        this.learning = data[0].learningTracker;
        // console.log(data)
      } catch (err) {
        if (err.response.statusText == "Unauthorized") {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async getCourse(name, item) {
      this.$router.push({ name: name });
      this.$store.commit("eLearning/selectedCourse", item);
      if (Object.keys(this.selectedTopics).length != 0) {
        if (this.selectedTopics.course.toString() != item._id) {
          this.$store.commit("eLearning/SET_SELECTED_TOPIC", {});
        }
      }
    },
    getTotalTopics(course) {
      // console.log(course);
      let count = 0;
      course.chapter.forEach((element) => {
        count += element.topic.length;
        count += element.embedded.length;
        count += element.question.length ? 1 : 0;
        // count += this.chapterByCourseId.length;
      });

      return count;
    },
    getCompletedTopics(course) {
      return this.learning.filter(
        (x) => x.course === course._id && x.status === "completed"
      ).length;
    },
    isApprovalCertificate(course) {
      return this.learning.find(
        (x) => x.course === course._id && x.status === "completed"
      ).approve;
    },
    getTotalPercentage(course) {
      return (
        (this.getCompletedTopics(course) / this.getTotalTopics(course)) * 100
      );
    },
    certificate(data) {
      this.$router.push({ name: "e-my-learning-e-certificate" });
      this.$store.commit("eLearning/SET_CERTIFICATE_COURSE", data);
    },
    getCertificate() {
      this.$swal.fire({
        text: "Request send for Certificate",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#60d394",
        showCancelButton: false,
      });
    },
  },
  mounted() {
    this.getStudent();
    // console.log(this.selectedTopics);
    // console.log(this.chapterByCourseId);
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("eLearning", { selectedTopics: "selectedTopics" }),
    ...mapState("eLearning", { chapterByCourseId: "chapterByCourseId" }),
  },
};
</script>
